<template>
  <v-layout justify-center>
    <v-flex>
      <panel :title="$t('bolusDetails.createBolus')">  
        <v-form ref="form">
        <v-text-field
          :label="$t('bolusGenerics.bolusName')"
          required
          :rules="[required]"
          v-model="bolus.bolus_name"
        ></v-text-field>
        <v-select 
          v-model="bolus.bolusType"
          :items="types"
          :label="$t('bolusDetails.bolusType')">
        </v-select>
        <v-text-field
          v-if="bolus.bolusType === 'nbiot'"
          label="Imei"
          required
          :rules="[required]"
          v-model="bolus.imei"
        ></v-text-field>
        <v-text-field
          v-if="bolus.bolusType === 'NB-IoT'"
          label="Imsi"
          required
          :rules="[required]"
          v-model="bolus.imsi"
        ></v-text-field>
        <v-text-field
          v-if="bolus.bolusType === 'LoRa'"
          :label="$t('bolusGenerics.deveui')"
          required
          :rules="[required]"
          v-model="bolus.deveui"
        ></v-text-field>

        <v-checkbox v-model="bolus.is_ph" :label="$t('bolusGenerics.isPh')"></v-checkbox>

        <h3 v-if="bolus.is_ph" class="ph-title">{{$t('bolusGenerics.pHCalibrationData')}}</h3>

        <div v-if="bolus.is_ph" >
          <date-time-picker-with-zone
            @dateChanged="newDate => (newPhConfig.valid_from = $moment(newDate))"
            :actDate="newPhConfig.valid_from"
          />
          <v-text-field
            :label="$t('bolusGenerics.fourPh')"
            required
            v-model="newPhConfig.four_ph_value"
          ></v-text-field>
          <v-text-field
            :label="$t('bolusGenerics.sevenPh')"
            required
            v-model="newPhConfig.seven_ph_value"
          ></v-text-field>
        </div>
        
        <div class="danger-alert" v-if="error">
          {{error}}
        </div>
        <v-btn
          dark
          class="secondary"
          @click="create">
          {{$t('bolusDetails.createBolus')}}
        </v-btn>
        </v-form>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import BolusApi from "@/api/bolus-api";
import UtilsService from "@/services/UtilsService";

export default {
  data () {
    return {
      bolus: {
        bolus_name: null,
        imei: null,
        bolusType: null,
        imsi: null,
        deveui: null,
        is_ph: false,
        phConfig: []
      },
      newPhConfig: {
        four_ph_value: null,
        seven_ph_value: null,
        valid_from: null
      },
      error: null,
      result: null,
      required: (value) => !!value || 'Required.',
      types: ['NB-IoT', 'LoRa']
    }
  },
  methods: {
    async create () {
      this.error = null
      if (this.$refs.form.validate()) {
        try {
          
          if (this.bolus.is_ph) {
            // add ph config
            if (
              this.newPhConfig.four_ph_value &&
              this.newPhConfig.seven_ph_value &&
              this.newPhConfig.valid_from
            ) {
              this.bolus.ph_four_value = +this.newPhConfig.four_ph_value;
              this.bolus.ph_seven_value = +this.newPhConfig.seven_ph_value;
              this.bolus.ph_valid_from = UtilsService.utcDate(this.newPhConfig.valid_from);
            }
          }

          await BolusApi.post(this.bolus);

          Object.assign(this.$data, this.$options.data.call(this))
          this.$emit('close')
        } catch (error) {
          console.error(error)
          this.error = error.response.data.error.message
        }
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CreateBolus.vue